export default {
  label: "Dirección de Facturación",
  name: "Nombre/Empresa",
  invoiceEmail: "Dirección de correo electrónico para facturación electrónica",
  address: "Dirección",
  PONumber: "Número de Orden de Compra",
  note: "Nota",
  requiredField: "Este campo es requerido.",
  emailErrorMessage: "Ingrese una dirección de correo electrónico válida de máximo 50 caracteres.",
  postalCodeErrorMessage: "Por favor ingresa un código postal válido que consista solo en dígitos.",
  deleteBillingAddress: "Eliminar Dirección de Facturación",
  deleteBillingAddressMessage: "¿Realmente quieres eliminar esta dirección de facturación?",
  deleteBillingAddressesNotPossible:
    "Eliminar la dirección de facturación no es posible ya que una de las direcciones está asociada con un activo.",
  deleteBillingAddressNotPossible:
    "No es posible eliminar la dirección de facturación ya que la factura está asociada con un activo.",
};
